import { useState, useEffect, useRef } from 'react';
import { Modal } from 'react-bootstrap';

import {
    getError, isUndNullEmpNew, sendMessageCloseCurrentWindow, settings, getLanguageObj, getResponse, isUndNullNew
} from '../../helpers/UtilsHelper';
import HtmlParser from 'react-html-parser';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { AuthContextType } from '../../auth/AuthContext';
import { LlmModelClass } from '../../classes/ai/LlmModelClass';
import { LargeLanguageModelClass } from '../../classes/ai/largeLanguageModelClass';
import { UserLlmClass, UserLlmModelClass, UserLlmModelSelectClass } from '../../classes/ai/UserLLmModelSelectClass';
import { UserLlmModelSelectService } from '../../services/largeLanguageModel/UserLlmModelSelectService';

const { html, icons, images, messages, labels, firebase } = settings;
const { fields: dbFields } = firebase?.firestore;

const currentMethod = 'UserLlmModelAddEdit - function';

export default function UserLlmModelSelectAddEdit({
    $ = {},
    auth = AuthContextType,
    processValues = { id: '', description: '', dtId: '', dtRowId: 0, type: 0, subMethod: '' },
    setProcessValues = () => { },
    showModal = false,
    setShowModal = () => { },
    largeLanguageModel = LargeLanguageModelClass?.getClass(),
    setLargeLanguageModel = () => { },
    userLlmModelSelect = UserLlmModelSelectClass?.getClass(),
    setUserLlmModelSelect = () => { },
    providerModel = UserLlmModelClass?.getClass(),
    setProviderModel = () => { },
    provider = UserLlmClass?.getClass(),
    setProvider = () => { },
    setDtRow = ({
        data = LlmModelClass?.getClass(),
        subMethod = '',
    } = {}) => { },
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const [errors, setErrors] = useState({
        code: '',
        priority: '',
    });
    const [process, setProcess] = useState({ showLoading: false, save: false, });
    const isMount = useRef(true);
    //#endregion variables

    //#region methods
    const llmModelAddEdit = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'llmModelAddEdit';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let provider_ = UserLlmClass?.getClass();
            let providers_ = [UserLlmClass?.getClass()];
            let providerModel_ = UserLlmModelClass?.getClass();
            let providerModels_ = [UserLlmModelClass?.getClass()];
            let userLlmModelSelect_ = UserLlmModelSelectClass?.getClass();
            //#endregion variables

            e?.preventDefault?.();

            response = formDataValidate({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            const data_ = userLlmModelSelect;
            provider_ = data_?.providers?.find(({ id: idLocal }) => idLocal === provider?.id) || {};
            providers_ = data_?.providers?.filter(({ id: idLocal }) => idLocal !== provider?.id) || [];
            providerModels_ = provider_?.models?.filter(({ id: idLocal }) => idLocal !== providerModel?.id) || [];

            provider_.models = [...providerModels_, { ...providerModel }];
            provider_.models = provider_?.models?.sort((a, b) => a?.priority - b?.priority);
            data_.providers = [...providers_, { ...provider_ }];
            data_.providers = data_.providers?.sort((a, b) => a?.priority - b?.priority);
            data_.languageId = languageObj?.id;

            setProcess(prev => ({ ...prev, showLoading: true, save: true }));

            if (processValues?.type === 0) {
                // response = await UserLlmModelSelectService?.create({
                //     data: data_,
                //     token: auth?.account?.tokenVzLaML?.token,
                //     subMethod: currentMethod
                // });
            } else if (processValues?.type === 1) {
                response = await UserLlmModelSelectService?.update({
                    id: userLlmModelSelect?.id,
                    data: data_,
                    token: auth?.account?.tokenVzLaML?.token,
                    subMethod: currentMethod
                });

            }
            if (!response?.isSuccess || response?.isWarning) return;

            userLlmModelSelect_ = response?.result || {};
            setUserLlmModelSelect(userLlmModelSelect_);

            provider_ = userLlmModelSelect_?.providers?.find(({ id }) => id === provider?.id) || UserLlmClass?.getClass();
            providerModel_ = provider_?.models?.find(({ id: idLocal }) => idLocal === processValues?.id) || UserLlmModelClass?.getClass();

            const dtRows = setDtRow({
                data: providerModel_,
                subMethod: currentMethod
            })?.result

            if (processValues?.type === 0) {
                $(`#${processValues?.dtId}`).DataTable().row.add(dtRows).draw();
                // setLlmModels(prev => [...prev, llmModel_]);
            } else if (processValues?.type === 1) {
                $(`#${processValues?.dtId}`).DataTable().row(processValues?.dtRowId).data(dtRows).draw();
                // setLlmModels(prev => prev.map((model) => model?.id === processValues?.id ? llmModel_ : model));
            }

            response.msgText = messages?.processCompletedSuccessfully?.[languageObj?.id];
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, save: false }));

            if (response?.isSuccess && !response?.isWarning) setShowModal(false);

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    };

    const formDataValidate = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'formDataValidate';
        let response = getResponse({ type: 0 });
        try {
            const errors_ = { code: '', priority: '' };
            const thisFieldRequired = messages?.thisFieldRequired?.[languageObj?.id];

            if (isUndNullEmpNew({ data: providerModel?.code, subMethod: currentMethod })?.result) {
                errors_.code = thisFieldRequired;
                response = getResponse({ type: 1 });
            }

            if (isUndNullNew({ data: providerModel?.priority, subMethod: currentMethod })?.result ||
                providerModel?.priority <= 0) {
                errors_.priority = thisFieldRequired;
                response = getResponse({ type: 1 });
            } else {
                const providerModelFound_ = provider?.models?.filter(({ id: idLocal, priority, }) => priority === providerModel?.priority && idLocal !== providerModel?.id) || [];
                if (providerModelFound_?.length > 0) {
                    response = getResponse({ type: 1 });
                    errors_.priority = messages?.multipleRecordsCannotHaveTheSamePriority?.[languageObj?.id];
                }
            }

            setErrors(errors_);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    };

    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!response?.isSuccess || response?.isWarning) setShowModal(false);

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    };

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad', });
        return () => { isMount.current = false; };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal show={showModal} onHide={() => setShowModal(false)} backdrop='static' centered contentClassName='border-0 shadow-lg login-card'>
            <Modal.Header closeButton className='bg-white border-bottom-0 pt-4 px-4 align-items-center'>
                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img alt='llmModel' src={images?.icons?.llmModel} style={{ width: '20px', height: '20px', objectFit: 'contain' }} />
                </div>
                <div className='d-flex flex-column'>
                    <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.model?.[languageObj?.id]}</span>
                    <div className='d-flex align-items-center mt-1'>
                        <span className={`badge badge-pill py-1 px-2 text-uppercase ${processValues?.type === 0 ? 'badge-info' : 'badge-warning'} text-dark`}
                            style={html?.badges?.micro}>
                            {processValues?.type === 0 ? labels?.add?.[languageObj?.id] : labels?.edit?.[languageObj?.id]}
                        </span>
                    </div>
                </div>
            </Modal.Header>

            <form onSubmit={(e) => llmModelAddEdit({ e: e, subMethod: 'onSubmit - form' })}>
                <Modal.Body className='px-4 pt-2'>
                    <div className='form-group mb-4'>
                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                            {labels?.largeLanguageModel?.[languageObj?.id]}
                        </label>
                        <div className='position-relative'>
                            <i className={`${icons?.fasFa?.brain} position-absolute input-icon-left`} />
                            <input className='form-control border-0 shadow-sm form-input-icon'
                                title={labels?.largeLanguageModel?.[languageObj?.id]}
                                type='text'
                                placeholder={labels?.largeLanguageModel?.[languageObj?.id]}
                                readOnly={true}
                                value={largeLanguageModel?.description || ''} />
                        </div>
                        {errors?.largeLanguageModel && <div className={html?.errorText}>{HtmlParser(errors?.largeLanguageModel || '')}</div>}
                    </div>

                    <div className='form-group mb-4'>
                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                            {labels?.model?.[languageObj?.id]}
                        </label>
                        <div className='position-relative'>
                            <i className={`${icons?.fasFa?.robot} position-absolute input-icon-left`} />
                            <input className='form-control border-0 shadow-sm form-input-icon'
                                title={labels?.model?.[languageObj?.id]}
                                type='text'
                                readOnly={true}
                                onChange={(e) => setProviderModel(prev => ({ ...prev, [dbFields?.code]: e?.target?.value }))}
                                onFocus={() => setErrors(prev => ({ ...prev, code: '' }))}
                                placeholder={labels?.model?.[languageObj?.id]}
                                disabled={process?.showLoading}
                                value={providerModel?.code || ''} />
                        </div>
                        {errors?.code && <div className={html?.errorText}>{HtmlParser(errors?.code || '')}</div>}
                    </div>

                    <div className='form-group mb-4'>
                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                            {labels?.priority?.[languageObj?.id]}
                        </label>
                        <div className='position-relative'>
                            <i className={`${icons?.fasFa?.sortNumericUpAlt} position-absolute input-icon-left`} />
                            <input className='form-control border-0 shadow-sm form-input-icon'
                                min={0}
                                max={99}
                                type='number'
                                // style={{ height: 'auto', paddingTop: '15px' }}
                                title={labels?.priority?.[languageObj?.id]}
                                onChange={(e) => setProviderModel(prev => ({ ...prev, [dbFields?.priority]: parseInt(e?.target?.value || 0) }))}
                                placeholder={labels?.priority?.[languageObj?.id]}
                                onFocus={() => setErrors(prev => ({ ...prev, priority: '' }))}
                                disabled={process?.showLoading}
                                value={providerModel?.priority || 0} />
                        </div>
                        {errors?.priority && <div className={html?.errorText}>{HtmlParser(errors?.priority || '')}</div>}
                    </div>

                    <div className='form-group mb-4'>
                        <div className='icheck-primary d-inline'>
                            <input type='checkbox'
                                id={'chkLlmModelId'}
                                checked={providerModel?.enabled || false}
                                onChange={(e) => setProviderModel(prev => ({ ...prev, [dbFields?.enabled]: e?.target?.checked }))}
                                disabled={process?.showLoading} />
                            <label htmlFor={'chkLlmModelId'} style={{ cursor: 'pointer' }}>
                                {labels?.enabled?.[languageObj?.id]}?
                            </label>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                    <div className='d-flex justify-content-center w-100'>
                        <button className='btn btn-primary shadow-sm font-weight-bold mx-1 px-4 btn-primary'
                            data-title={labels?.save?.[languageObj?.id]}
                            type='submit'
                            disabled={process?.showLoading}>
                            {!process?.save ? (
                                <i className={`${icons?.fasFa?.save} mr-1`}></i>
                            ) : (
                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                            )} {labels?.save?.[languageObj?.id]}
                        </button>
                        <button className='btn btn-light border shadow-sm font-weight-bold mx-1 px-4 text-secondary btn-general'
                            data-title={labels?.close?.[languageObj?.id]}
                            type='button'
                            disabled={process?.showLoading}
                            onClick={() => setShowModal(false)}>
                            <i className={`${icons?.fasFa?.arrowAltCircleLeft} mr-1`}></i> {labels?.close?.[languageObj?.id]}
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}